export const DASHBOARD_REGIONS = [
  { key: 'pakistan', label: 'Pakistan', icon: '🇵🇰', hint: 'Province & district view' },
  { key: 'asia', label: 'Asia', icon: '🌏', hint: 'Regional overview' },
  { key: 'iofs', label: 'IOFS Members', icon: '🌾', hint: 'Food security bloc' },
  { key: 'australia', label: 'Australia', icon: '🇦🇺', hint: 'States & territories' },
  { key: 'new-zealand', label: 'New Zealand', icon: '🇳🇿', hint: 'Regional councils' },
];

export const DEFAULT_DASHBOARD_REGION = 'pakistan';

const REGION_URL_PARAM = 'region';

export function getDashboardRegion(key) {
  return DASHBOARD_REGIONS.find(region => region.key === key) || DASHBOARD_REGIONS[0];
}

/**
 * Reads ?region=<key> from the current URL. Falls back to the default
 * region if the param is missing or not a recognised region key — so a
 * stale or hand-edited URL never breaks the page, it just shows Pakistan.
 */
export function getRegionFromURL() {
  const params = new URLSearchParams(window.location.search);
  const key = params.get(REGION_URL_PARAM);
  const known = DASHBOARD_REGIONS.some(region => region.key === key);
  return known ? key : DEFAULT_DASHBOARD_REGION;
}

/**
 * Writes ?region=<key> into the URL without reloading the page or adding
 * a new browser-history entry (replaceState, not pushState) — region
 * switches read like a filter/tab change, not page navigation. This is
 * what makes the current view shareable: copying the address bar URL
 * after picking a region reproduces that exact selection for anyone who
 * opens it.
 */
export function setRegionInURL(key) {
  const url = new URL(window.location.href);
  if (key === DEFAULT_DASHBOARD_REGION) {
    url.searchParams.delete(REGION_URL_PARAM);
  } else {
    url.searchParams.set(REGION_URL_PARAM, key);
  }
  window.history.replaceState(window.history.state, '', url);
}
